import { OBSTRUCTED, SEATRADIUS } from '@/constants';
import SVG from 'svg.js';
import Application from '../application';

export interface ObstructedRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
  app: Application;
  selected: boolean;
  shape: SVG.Shape;
}

export const ObstructedMixin = <T extends { new (...args: any[]): ObstructedRequirements }>(base: T) => {
  return class ObstructedMixin extends base {
    obstructedShape: SVG.Path | null = null;

    get obstructed() {
      return this.attributes.obstructed === true;
    }

    set obstructed(value) {
      this.attributes.obstructed = value;
      this.toggleObstructedIconVisibility();
    }

    toggleObstructedIconVisibility() {
      if (this.obstructed) {
        this.initObstructedShape();
      } else {
        this.removeObstructedShape();
      }
    }

    initObstructedShape([cx, cy] = this.attributes.position) {
      if (this.obstructedShape?.node) return;

      this.removeObstructedShape();

      const size = (SEATRADIUS - 2) * this.app.seatmap.scale;

      this.obstructedShape = this.view
        .path(OBSTRUCTED.SHAPE)
        .size(size * 2)
        .center(cx + 1.5 * this.app.seatmap.scale, cy + 1.5 * this.app.seatmap.scale)
        .stroke('none')
        .fill({ color: this.app.getCategoryColor(this.attributes.categoryId)!, opacity: 0.5 });

      this.shape.addClass('obstructed');
    }

    removeObstructedShape() {
      this.obstructedShape && this.obstructedShape.remove();
      this.obstructedShape = null;
      this.shape.removeClass('obstructed');
    }

    updateObstructedShape(x: number, y: number) {
      if (this.obstructedShape) {
        const size = (SEATRADIUS - 2) * this.app.seatmap.scale;
        this.obstructedShape.size(size * 2).center(x + 1.5 * this.app.seatmap.scale, y + 1.5 * this.app.seatmap.scale);
      }
    }
  };
};
